export default __webpack_public_path__ + "static/media/image11.a9baa83e.jpg";